module.exports = __webpack_public_path__ + "img/hatul_no.a9da00d8.png";